import { Tag } from 'antd';
import { formatDate } from '@/utils/datetime';

// ==============================|| PRODUCTION SCHEDULER - SHARED HELPERS ||============================== //

export const fmtDate = (v) => (v ? formatDate(v) : '—');

export const priorityTagColor = (priority = '') => {
  const v = String(priority).toLowerCase();
  if (v === 'high') return 'red';
  if (v === 'medium') return 'orange';
  if (v === 'low') return 'blue';
  return 'default';
};

export const demandStatusTagColor = (status = '') => {
  const v = String(status).toLowerCase();
  if (v === 'approved') return 'success';
  // Covers both the simple 'Submitted' status and the workflow engine's dynamic
  // 'Pending <Role> Approval' strings (e.g. "Pending QA Approval") — same color either way.
  if (v === 'submitted' || v.startsWith('pending')) return 'processing';
  if (v === 'rejected' || v.startsWith('rejected')) return 'error';
  return 'default'; // Draft
};

// A demand can be (re)submitted from Draft, or after any rejection — resubmitting
// always starts a fresh approval cycle at Step 1 (see the workflow spec's rejection
// & resubmission rule). Once Submitted/Pending/Approved it can't be submitted again.
export const canSubmitForApproval = (status = '') => {
  const v = String(status).toLowerCase();
  return v === 'draft' || v === 'rejected' || v.startsWith('rejected');
};

// The 3-role whitelist for the Demand Batch approval workflow's Role dropdown moved to
// @/utils/approvalRoles (isApprovalRole) — shared with Process Library's "Send to
// Approval" feature and the recipe/batch approval-status checklists. Import it directly
// from there instead of through this file.

export const workflowStepStatusColor = (status = '') => {
  const v = String(status).toLowerCase();
  if (v === 'approved') return 'success';
  if (v === 'rejected') return 'error';
  if (v === 'skipped') return 'default';
  if (v === 'in_progress' || v === 'pending') return 'processing';
  return 'default'; // Not Started / Waiting
};

// Matches the running-batches API's own status vocabulary (Scheduled vs Running) so a
// freshly-created, unstarted lot reads the same way here as it will once it shows up there.
export const lotStatusTag = () => <Tag color="blue">Scheduled</Tag>;

export const personName = (person) => (person?.name ? person.name : '—');
